import React from 'react'
import clsx from 'clsx'

import useStyles from './styles'

const DownArrow: React.FC<React.HTMLAttributes<SVGSVGElement>> = props => (
  <svg
    width='16'
    height='16'
    viewBox='0 0 16 16'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
    {...props}
  >
    <path
      d='M11.9465 5.45312H7.79316H4.05317C3.41317 5.45312 3.09317 6.22646 3.5465 6.67979L6.99983 10.1331C7.55317 10.6865 8.45317 10.6865 9.0065 10.1331L10.3198 8.81979L12.4598 6.67979C12.9065 6.22646 12.5865 5.45312 11.9465 5.45312Z'
      fill='#1F1F1F'
    />
  </svg>
)

interface FakeMenuProps extends React.HTMLAttributes<HTMLDivElement> {}

const FakeMenu: React.FC<FakeMenuProps> = ({
  className,
  children,
  ...props
}) => {
  const classes = useStyles()

  return (
    <div className={clsx(classes.root, className)} {...props}>
      {children}

      <DownArrow />
    </div>
  )
}

export default FakeMenu
